/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721ReceiverMock,
  ERC721ReceiverMockInterface,
} from "../ERC721ReceiverMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "retval",
        type: "bytes4",
      },
      {
        internalType: "enum ERC721ReceiverMock.Error",
        name: "error",
        type: "uint8",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "gas",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721ReceiverMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721ReceiverMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721ReceiverMock__factory extends ContractFactory {
  constructor(...args: ERC721ReceiverMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721ReceiverMock";
  }

  deploy(
    retval: BytesLike,
    error: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721ReceiverMock> {
    return super.deploy(
      retval,
      error,
      overrides || {}
    ) as Promise<ERC721ReceiverMock>;
  }
  getDeployTransaction(
    retval: BytesLike,
    error: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(retval, error, overrides || {});
  }
  attach(address: string): ERC721ReceiverMock {
    return super.attach(address) as ERC721ReceiverMock;
  }
  connect(signer: Signer): ERC721ReceiverMock__factory {
    return super.connect(signer) as ERC721ReceiverMock__factory;
  }
  static readonly contractName: "ERC721ReceiverMock";
  public readonly contractName: "ERC721ReceiverMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721ReceiverMockInterface {
    return new utils.Interface(_abi) as ERC721ReceiverMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721ReceiverMock {
    return new Contract(address, _abi, signerOrProvider) as ERC721ReceiverMock;
  }
}
